import styled from 'styled-components';
import { AutoComplete as AutoCompleteEnhancement, Select } from 'antd';
import type { SelectProps } from 'antd/es/select';

interface IAutoComplete {
  status?: 'error' | 'success';
}

export const MappingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  padding-top: 0;
  background: #fff;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const AddNewEvent = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 6px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  cursor: pointer;
  color: #0046ff;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0046ff;
    background: #f0f5ff;
  }

  &:active {
    transform: translateY(1px);
  }
`;

// EventBox styled components
export const RawEvent = styled.div<{ isHighlight?: boolean }>`
  border: 1px solid ${(props) => (props.isHighlight ? '#0046ff' : '#e8e8e8')};
  border-radius: 4px;
  background: #fff;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: #0046ff;
    box-shadow: 0 2px 8px rgb(0 70 255 / 10%);
  }

  &.active {
    border-color: #0046ff;
    box-shadow: 0 2px 8px rgb(0 70 255 / 15%);
  }
`;

export const RawEventTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  border-radius: 4px 4px 0 0;
`;

export const OrTag = styled.span`
  background: var(--Fill-BgBase, #f5f5f5);
  color: var(--Text-TextPrimary, #000);
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid var(--Stroke-BorderSolidDark, #bfbfbf);
  margin-right: 12px;
  line-height: 18px;
`;

export const DeleteIcon = styled.span`
  .ant-btn {
    border: none;
    box-shadow: none;

    &:hover {
      background: #ff4d4f;

      svg {
        fill: white;
      }
    }
  }
`;

// RuleItem styled components
export const RuleRow = styled.div`
  --rule-row-gap: 6px;

  display: flex;
  align-items: center;
  gap: var(--rule-row-gap);
  margin-bottom: 16px;
`;

export const OrWidth = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 70px;
  width: 70px;
`;

export const ReadOnly = styled.span`
  display: inline-block;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #f5f5f5;
  color: rgb(0 0 0 / 88%);
  height: 28px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: not-allowed;
`;

export const RawEventContent = styled.div`
  padding: 16px;
  padding-bottom: 0;
  padding-right: 0;
`;

export const AndRuleContent = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AndRuleLine = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0;
  position: relative;
`;

export const LineLeft = styled.div`
  flex: 1;
  height: 1px;
  background: #d9d9d9;
`;

export const AndText = styled.div`
  padding: 0 12px;
  background: #fff;
  color: #595959;
  font-size: 12px;
  font-weight: 500;
`;

export const LineRight = styled.div`
  flex: 1;
  height: 1px;
  background: #d9d9d9;
`;

export const RawEventFooter = styled.div`
  display: flex;
  gap: 16px;
  padding: 0 16px 12px 94px;

  span {
    color: #0046ff;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`;
export const CusSelect = styled(Select)`
  &&.emp-ant-select {
    width: 100%;
    min-width: 150px;
    color: rgb(0 0 0 / 85%);

    .emp-ant-select-selector {
      width: 100%;
      height: 28px;
      border-radius: 3px;
      border: solid 1px #bfbfbf;
      background-color: #fff;

      &:hover {
        border: solid 1px rgb(0 0 0 / 15%);
      }

      .emp-ant-select-selection-item {
        letter-spacing: -0.01em;
        line-height: 26px;
      }
    }

    .emp-ant-select-clear {
      background: transparent !important;
    }

    .emp-ant-select-selection-placeholder {
      color: rgb(0 0 0 / 45%);
      font-weight: 400;
    }
  }

  &&.emp-ant-select-disabled.emp-ant-select:not(.emp-ant-select-customize-input)
    .emp-ant-select-selector {
    color: rgb(0 0 0 / 88%);
  }
`;
export const AutoComplete = styled(AutoCompleteEnhancement)<IAutoComplete>`
  &&.emp-ant-select {
    .emp-ant-select-selector {
      height: 28px;
      border-radius: 3px;
      border: solid 1px #bfbfbf;
      width: 100%;

      .emp-ant-select-selection-search-input {
        height: 100%;
      }

      .emp-ant-select-selection-item {
        letter-spacing: -0.01em;
        line-height: 26px;
      }

      .emp-ant-select-selection-search {
        height: 28px;

        .emp-ant-input-affix-wrapper {
          border-color: ${(props) => (props.status === 'error' ? '#ff4d4f' : 'transparent')};
          padding: 0 20px 0 11px;

          .emp-ant-input {
            &::placeholder {
              color: rgb(0 0 0 / 25%);
            }
          }
        }

        &:hover .emp-ant-input-affix-wrapper {
          border-color: #2969ff;
        }
      }
    }

    .emp-ant-select-selection-placeholder {
      color: rgb(0 0 0 / 45%);
      line-height: 28px;
      letter-spacing: -0.14px;
    }
  }
`;
export const SelectStyled = styled(Select)<SelectProps>`
  &&.emp-ant-select {
    width: 100%;
    min-width: 150px;
    color: rgb(0 0 0 / 85%);
  }
`;
